import { visibleCategories } from '../../helpers/schedule';

// Botones del home (columna derecha). `category` es el nombre de la categoria
// en el admin; `sub` abre la pantalla de subcategorias en vez de una lista.
// Lunch Menu solo se muestra en su horario (ver helpers/schedule.js).
export const CATEGORY_BUTTONS = [
    { key: 'lunch-menu', category: 'LUNCH MENU' },
    { key: 'food-menu', sub: 'food' },
    { key: 'drinks', sub: 'drinks' },
    { key: 'sides', category: 'SIDES' },
    { key: 'appetizers', category: 'APPETIZERS' },
    { key: 'salads', category: 'SALADS' },
    { key: 'kids-menu', category: 'KIDS MENU' },
    { key: 'desserts', category: 'DESSERTS' }
];

export const SUBCATEGORIES = {
    food: {
        images: require.context('./assets/home/food', false, /\.png$/),
        buttons: [
            { key: 'steaks', category: 'STEAKS' },
            { key: 'seafood', category: 'SEAFOOD' },
            { key: 'entrees', category: 'ENTREES' },
            { key: 'chicken', category: 'CHICKEN' },
            { key: 'enchiladas', category: 'ENCHILADAS' },
            { key: 'fajitas', category: 'FAJITAS' },
            { key: 'tacos-grilled', category: 'TACOS GRILLED' },
            { key: 'dips-nachos', category: 'DIPS & NACHOS' },
            { key: 'bbq', category: 'BBQ' },
            { key: 'veggie', category: 'VEGGIE' },
            { key: 'make-your-own-combo', category: 'MAKE YOUR OWN COMBO', wide: true }
        ]
    },
    drinks: {
        images: require.context('./assets/home/drinks', false, /\.png$/),
        buttons: [
            { key: 'specialty-cocktails', category: 'SPECIALTY COCKTAILS', wide: true },
            { key: 'margaritas', category: 'MARGARITAS' },
            { key: 'wine', category: 'WINE' },
            { key: 'whiskey', category: 'WHISKEY' },
            { key: 'tequila', category: 'TEQUILA' },
            { key: 'beer', category: 'BEER' },
            { key: 'sodas', category: 'SODAS' },
            { key: 'hot-beverages', category: 'HOT BEVERAGES' },
            { key: 'juices-fresh-waters', category: 'JUICES & FRESH WATERS' }
        ]
    }
};

// Pestañas de la lista de productos. Food incluye tambien las categorias que en
// el home tienen boton propio y las que no tienen boton (lunch, burritos).
export const LIST_TABS = [
    {
        key: 'food',
        label: 'FOOD MENU',
        categories: [
            ...SUBCATEGORIES.food.buttons.map((button) => button.category),
            'BURRITOS & QUESADILLAS',
            'APPETIZERS',
            'SALADS',
            'SIDES',
            'KIDS MENU',
            'DESSERTS',
            'LUNCH MENU',
            'L FAJITAS',
            'L STEAKS'
        ]
    },
    {
        key: 'drinks',
        label: 'DRINKS',
        categories: SUBCATEGORIES.drinks.buttons.map((button) => button.category)
    }
];

// Busca la categoria por nombre exacto. Las que en el admin estan divididas
// ("BEER > IMPORTED", "BEER > DOMESTIC"...) se juntan en una sola lista.
export const findCategory = (menus, name, now = new Date()) => {
    const target = name.toUpperCase();
    const found = visibleCategories(menus, now).filter((item) => {
        const itemName = (item.name || '').toUpperCase().trim();
        return itemName === target || itemName.startsWith(`${target} >`);
    });

    if (found.length <= 1) return found[0] || null;
    return { ...found[0], name, language: [], menus: found.flatMap((item) => item.menus || []) };
};
